import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { loginSuccess } from '../slices/authSlice';

const useDashboardStripeReturn = ({ onCheckoutSuccess, onCheckoutCanceled } = {}) => {
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            return;
        }

        if (!location.search) {
            return;
        }

        const params = new URLSearchParams(location.search);
        const sessionId = params.get('session_id');
        const checkoutSuccess = params.get('checkoutSuccess') === 'true';
        const checkoutCanceled = params.get('checkoutCanceled') === 'true';

        if (!sessionId && !checkoutSuccess && !checkoutCanceled) {
            return;
        }

        const clearQueryParams = () => {
            navigate(location.pathname, { replace: true });
        };

        const verifyAndRefresh = async () => {
            try {
                if (sessionId) {
                    await axios.get(`api/billing/checkout-session/${sessionId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                }
            } catch (error) {
                console.error('Error verifying Stripe checkout session:', error);
            }

            try {
                const { data } = await axios.get('api/users/me', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (data) {
                    dispatch(loginSuccess({ token, user: data }));
                }
            } catch (error) {
                console.error('Error refreshing user after Stripe checkout:', error);
            }

            if (checkoutSuccess && typeof onCheckoutSuccess === 'function') {
                onCheckoutSuccess();
            }

            if (checkoutCanceled && typeof onCheckoutCanceled === 'function') {
                onCheckoutCanceled();
            }
        };

        verifyAndRefresh().finally(clearQueryParams);
    }, [token, location.search, location.pathname, navigate, dispatch, onCheckoutSuccess, onCheckoutCanceled]);
};

export default useDashboardStripeReturn;
